import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, Outlet, useNavigate, useSearchParams} from "react-router-dom";
import {Breadcrumb, Button, Col, Collapse, DatePicker, Form, Row, Select, Space, Table, Typography,} from "antd";
import Input from "antd/es/input/Input";
import {FilterOutlined, ReloadOutlined, SearchOutlined,} from "@ant-design/icons";
import axios from "axios";
import moment from "moment/moment";
import {Context} from "../../../App";
import DB_Branch from "../../../database/dictionary/branch";
import ModalWindow from "../../modal";
import {isNullForm} from "../../tech/check";
import DB_OrgStructure from "../../../database/dictionary/org_structures";
import DB_Payments from "../../../database/mobile/db_payments";
import {DebounceSelect} from "../../tech/search_input";
import NextButton from "../../tech/next_button";

const Payments = () => {
    const {token, user, defaultPageSize, setToken} = useContext(Context)
    const {getPayments} = DB_Payments(token)
    const {getActiveBranches} = DB_Branch(token)
    const {getOrgStructureFilter} = DB_OrgStructure(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const navigate = useNavigate()
    const p = new URLSearchParams(window.location.search)
    const controller = new AbortController()
    const [form] = Form.useForm()
    const [showFilters, setShowFilters] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams({})
    const [search, setSearch] = useState({});
    const [countFilters, setCountFilters] = useState(0)



    const [data, setData] = useState([])
    const [date, setDate] = useState()
    const [wait, setWait] = useState(false)
    const [branch, setBranch] = useState([])
    const [totalSum, setTotalSum] = useState(null)


    const [pagination, setPagination] = useState({
        //current: 1,
        pageSize: defaultPageSize,
        //total:200,
        showSizeChanger: false
    })

    const clearFilter = () => {
        form.setFieldsValue({
                date: null,
                trade_point_code: null,
                trade_point: null,
                branch: null,
                org_structure: null,
                org_structure_name: null,
                invoice_number: null
            }
        )
        setSearch(current => {
            const {date, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {trade_point_code, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {trade_point, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {branch, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {org_structure, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {org_structure_name, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {invoice_number, ...rest} = current
            return rest
        })

        filterDate()
    }



    const filterDate = (lDate, dateString) => {
        if (lDate == null) {
            setDate(moment())
            setSearch(prevState => ({
                ...prevState,
                date: moment().format('YYYY-MM-DD')
            }))
            form.setFieldsValue({
                    date: moment()
                }
            )
        } else {
            setDate(moment(lDate, 'DD.MM.YYYY'))
            setSearch(prevState => ({
                ...prevState,
                date: moment(lDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
            }))
        }
    }

    const Filters = () => {
        return (
            <>
                <Form
                    form={form}
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    layout={"vertical"}
                    style={{marginTop: '-10pt'}}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setFilter()
                        }
                    }}
                >
                    <Row gutter={24}>
                        <Col span={8}>
                            <Form.Item
                                name='date'
                                label={t('date')}
                            >
                                <DatePicker
                                    defaultValue={date}
                                    value={date}
                                    onChange={e => filterDate(e)}
                                    format={'DD.MM.YYYY'}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name='trade_point_code'
                                label={t('code_distributor')}
                            >
                                <Input allowClear/>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                name='trade_point'
                                label={t('trade_point')}
                            >
                                <Input allowClear/>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                name='branch'
                                label={t('branch')}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="name"
                                    optionLabelProp="name"
                                    allowClear>
                                    {
                                        branch.map(b =>
                                            <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name='org_structure'
                                label={t('org_structure')}
                            >
                                <DebounceSelect
                                    // mode="multiple"
                                    showSearch
                                    fetchOptions={getOrgStructureFilter}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Space
                    style={{marginTop: '-10pt', marginBottom: '20pt', width: '100%', justifyContent: 'flex-end'}}>
                    <Button icon={<ReloadOutlined/>} onClick={clearFilter}>{t('clear')}</Button>
                    <Button type={"primary"} icon={<SearchOutlined/>}
                            onClick={setFilter}>{t('search')}</Button>
                </Space>

            </>
        )
    }

    const setFilter = () => {
        if (isNullForm(form.getFieldValue('trade_point_code'))) {
            setSearch(current => {
                const {trade_point_code, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                trade_point_code: form.getFieldValue('trade_point_code')
            }))
            setCountFilters(countFilters + 1)
        }
        if (isNullForm(form.getFieldValue('trade_point'))) {
            setSearch(current => {
                const {trade_point, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                trade_point: form.getFieldValue('trade_point')
            }))
            setCountFilters(countFilters + 1)
        }

        if (isNullForm(form.getFieldValue('branch'))) {
            setSearch(current => {
                const {branch, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                branch: form.getFieldValue('branch')
            }))
            setCountFilters(countFilters + 1)
        }

        if (isNullForm(form.getFieldValue('org_structure'))) {
            setSearch(current => {
                const {org_structure, ...rest} = current
                return rest
            })
            setSearch(current => {
                const {org_structure_name, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                org_structure_name: form.getFieldValue('org_structure').label,
                org_structure: form.getFieldValue('org_structure').value,

            }))
            setCountFilters(countFilters + 1)
        }

        setSearch(current => {
            const {page, ...rest} = current
            return rest
        })
    }

    const getData = (page, size) => {
        if (wait) {
            controller.abort()
        }
        setWait(true)

        searchParams.append('page', page)
        searchParams.append('size', size)
        getPayments(controller, searchParams)
            .then(res => {
                setData(res.data.data.details)
                setTotalSum(res.data.data.total)
                setPagination({
                    ...pagination,
                    current: res.data.page,
                    total: res.data.count,
                    pageSize: res.data.size
                })

                setWait(false);
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                }
            })
    }


    const columns = [
        {
            title: t('date'),
            dataIndex: 'date',
            render:(date) => moment.utc(date).format("DD.MM.YYYY HH:mm")
        },
        {
            title: <> {t('invoice_number_date')}<br/>{t('invoice_number')} </>,
            dataIndex: 'invoice_number',
            render: (invoice_number, record) =>
                <>
                    {record.invoice_number_date? moment(record.invoice_number_date).format("DD.MM.YYYY") : null}
                    <br/>
                    {invoice_number}
                </>
        },
        {
            title: <> {t('code')}<br/>{t('branch')}<br/>{t('trade_point')} </>,
            dataIndex: 'trade_point_code',
            render: (code, record) =>
                <>
                    {code}
                    <br/>
                    {record.branch}
                    <br/>
                    {record.trade_point}
                </>
        },

        {
            title: t('org_structure'),
            dataIndex: 'org_structure',
        },
        {
            title: t('repay'),
            dataIndex: 'repay',
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={record.trade_point_id} state={{path: searchParams.toString()}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ]

    useEffect(() => {
        window.scroll(0, 0)
        if (p.get("page") > 1) {
            setSearch(prevState => ({
                ...prevState,
                page: p.get("page")
            }))
        } else {
            setSearch(current => {
                const {page, ...rest} = current
                return rest
            })
        }
        if (p.get("size") > 1) {
            setSearch(prevState => ({
                ...prevState,
                size: p.get("size")
            }))
        } else {
            setSearch(current => {
                const {size, ...rest} = current
                return rest
            })
        }
        if (p.has('trade_point_code')) {
            setSearch(prevState => ({
                ...prevState,
                trade_point_code: p.get("trade_point_code")
            }))
            form.setFieldsValue({
                    trade_point_code: p.get("trade_point_code")
                }
            )
        }

        if (p.has('trade_point')) {
            setSearch(prevState => ({
                ...prevState,
                trade_point: p.get("trade_point")
            }))
            form.setFieldsValue({
                    trade_point: p.get("trade_point")
                }
            )
        }

        if (p.has('branch')) {
            setSearch(prevState => ({
                ...prevState,
                branch: p.get("branch")
            }))
            form.setFieldsValue({
                    branch: parseInt(p.get("branch"))
                }
            )
        }

        if (p.has('org_structure_name') ?? p.has('org_structure')) {
            form.setFieldsValue({
                    org_structure: p.get("org_structure_name")
                }
            )
            setSearch(prevState => ({
                ...prevState,
                org_structure_name: p.get("org_structure_name")
            }))

            setSearch(prevState => ({
                ...prevState,
                org_structure: p.get("org_structure")
            }))
        }

        if (p.has('date')) {
            setDate(moment(p.get("date"),'YYYY-MM-DD'))
            setSearch(c => ({
                ...c,
                date: p.get("date")
            }))

        } else {
            setDate(moment())
            setSearch(c => ({
                ...c,
                date: moment().format('YYYY-MM-DD')
            }))
        }
    }, [])

    useEffect(() => {
        setSearchParams(search)
        countButtonFilters()
    }, [search])

    useEffect(() => {
        getData(p.get("page"), defaultPageSize)
    }, [searchParams])

    const countButtonFilters = () => {
        let cnt = 0
        if (search.trade_point_code !== undefined) { cnt += 1 }
        if (search.trade_point !== undefined) { cnt += 1 }
        if (search.branch !== undefined) { cnt += 1 }
        if (search.org_structure_name !== undefined) { cnt += 1 }

        if (cnt === 0) {
            setCountFilters()
            setShowFilters(false)
        } else {
            setCountFilters(cnt)
            setShowFilters(true)
        }
    }

    useEffect(() => {
        axios.all([getActiveBranches()])
            .then(axios.spread((branch) => {
                setBranch(branch.data)
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })
    }, [])

    const paginatorChange = (pagination, filters, sorter) => {
        if (pagination.current === 1) {
            setSearch(current => {
                const {page, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                page: pagination.current
            }))
        }

        if (pagination.pageSize === defaultPageSize) {
            setSearch(current => {
                const {size, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                size: pagination.pageSize
            }))
        }
        window.scrollTo(0, 0)
    };

    const TotalSum = () => {
      if (totalSum != null) {
          return (
                  <Typography.Title level={5} style={{textAlign:'end', margin:'10pt 0'}}>
                      {t('total')}: {totalSum}
                  </Typography.Title>
          )
      }
    }


    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('payments')}
                            </span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    {/*<Space>*/}
                    {/*    <Link key='1' to="/finance/pay-forms/new" state={{id: null}}>*/}
                    {/*        <Button type={'primary'} shape={'round'} icon={<PlusCircleOutlined/>}>{t('add')}</Button>*/}
                    {/*    </Link>*/}
                    {/*</Space>*/}
                </Space>

                <Collapse ghost expandIconPosition={'right'}>
                    <Collapse.Panel header={
                        <Space style={{
                            display: 'flex',
                            alignItems: 'end',
                            flexDirection: 'column',
                            flex:'auto'
                        }}>
                            <Button type={'text'} icon={<FilterOutlined/>}> {countFilters}</Button>
                        </Space>
                    }
                                    key="1"
                    >
                        <Filters/>
                    </Collapse.Panel>
                </Collapse>

                <TotalSum/>

                <Table
                    style={{'--cursor': "auto" }}
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    loading={wait}
                    pagination={pagination}
                    size={"small"}
                    onChange={paginatorChange}
                    // onRow={(record, rowIndex) => {
                    //     return {
                    //         onClick: event => {
                    //             // if (user.role_id === 1) {
                    //             navigate(`${record.trade_point_id}`, {state: {id: record.id, path: searchParams.toString()}})
                    //             // }
                    //         },
                    //     };
                    // }}
                />


            </div>
            <Outlet/>
        </>
    )

}

export default Payments